import { mediaPicks } from "@/mocks/chigua";

export default function MediaSection() {
  const featured = mediaPicks[0];
  const rest = mediaPicks.slice(1);

  return (
    <section id="media" className="py-14 md:py-20 bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-2 text-primary-600 text-sm font-medium mb-2">
              <span className="w-8 h-0.5 bg-primary-500 rounded-full"></span>
              深度内容 · 观点文章
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
              不止吃瓜,更懂门道
            </h2>
          </div>
          <a
            href="#subscribe"
            className="inline-flex items-center gap-2 self-start md:self-auto px-4 py-2 rounded-md bg-secondary-500 text-background-50 text-sm whitespace-nowrap hover:bg-secondary-600 transition-colors"
          >
            订阅深度周报
            <i className="ri-mail-send-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="grid lg:grid-cols-2 gap-5 md:gap-6 items-stretch">
          {/* 左侧主推 */}
          <article className="group relative overflow-hidden rounded-xl min-h-[360px] md:min-h-[420px] flex items-end">
            <img
              src={featured.cover}
              alt={featured.title}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/25 to-transparent"></div>
            <div className="relative p-6 md:p-7">
              <div className="flex items-center gap-2 flex-wrap mb-3">
                <span className="px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs whitespace-nowrap">
                  主编推荐
                </span>
                <span className="px-2.5 py-1 rounded-md bg-background-50/20 text-background-100 text-xs whitespace-nowrap">
                  {featured.category}
                </span>
                <span className="text-xs text-background-300 whitespace-nowrap">
                  {featured.reads} 阅读
                </span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 leading-snug">
                {featured.title}
              </h3>
              <p className="mt-2 hidden md:block text-sm text-background-200 leading-relaxed line-clamp-2">
                {featured.excerpt}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-accent-300 text-sm whitespace-nowrap">
                阅读全文
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
              </span>
            </div>
          </article>

          {/* 右侧列表 */}
          <div className="flex flex-col gap-4">
            {rest.map((m) => (
              <article
                key={m.title}
                className="group flex gap-4 items-stretch rounded-xl bg-background-50 border border-background-200 p-3 overflow-hidden"
              >
                <div className="relative overflow-hidden rounded-lg w-32 sm:w-40 shrink-0">
                  <img
                    src={m.cover}
                    alt={m.title}
                    className="w-full h-full min-h-[104px] object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col justify-center py-1 pr-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-800 text-xs whitespace-nowrap">
                      {m.category}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{m.time}</span>
                  </div>
                  <h4 className="font-heading mt-2 text-sm md:text-base font-bold text-foreground-900 leading-snug line-clamp-2">
                    <a href="#faq" className="hover:text-primary-600 transition-colors">
                      {m.title}
                    </a>
                  </h4>
                  <p className="mt-1.5 text-xs text-foreground-600 line-clamp-2 leading-relaxed hidden sm:block">
                    {m.excerpt}
                  </p>
                  <span className="mt-2 inline-flex items-center gap-1 text-xs text-primary-600 whitespace-nowrap">
                    {m.reads} 阅读
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}